// imported in base router.ts
export default
	[
		{
			path: "/contentstreamsub/:id/",
			name: "streamsub",
			component: () => import("@/Views/Store/StreamSubscription.vue"),
			props: true,
			meta: { name: "Stream Subscription", page: "subscription" }
		},
		{
			path: "/pushwordpress/:id/",
			name: "pushwordpress",
			component: () => import("@/Views/Store/PushToWordpress.vue"),
			props: true,
			meta: { name: "Push articles to wordpress", page: "account" }
		},
	];
